import { Box } from "@mui/material";
import { useParams } from "react-router";
import CreateEditIncidentLogDialog from "../incidentLogDialog/CreateEditIncidentLogDialog.tsx";
import { DotLegalHeader, DotLegalPdfBackPage } from "@dotlegal/dotlegal-ui-components";
import { useSetPdfPageSize } from "../../common/pdfPageSizeHelper.ts";
import IncidentDocumentTab from "../incidentLogOverview/documents/IncidentDocumentTab.tsx";
import { useCreateEditIncidentStyles } from "../incidentLogDialog/CreateEditIncidentLogDialog.styles.ts";
import { useIncidentDocuments } from "../incidentLogOverview/documents/IncidentDocument.hooks.ts";
import IncidentDocumentTable from "../incidentLogOverview/documents/IncidentDocumentTable.tsx";
import React from "react";
import { useTranslation } from "../../localization/useTranslation.ts";

function IncidentLogPdf() {
    const { id } = useParams<{ id: string }>();
    const { translateString } = useTranslation();
    const styles = useCreateEditIncidentStyles();
    useSetPdfPageSize("landscape");

    const { isLoading: documentsIsLoading, data: documents } = useIncidentDocuments(id!);
    const hasDocuments = documentsIsLoading || (documents ?? []).length > 0;

    return (
        <Box
            sx={(theme) => ({
                width: "100vw",
                maxWidth: "1300px",
                [theme.breakpoints.down("sm")]: {
                    maxWidth: "100%",
                },
            })}
        >
            <Box sx={{ margin: 2, display: "flex", flexDirection: "column", gap: 3 }}>
                <CreateEditIncidentLogDialog closeDialog={() => {}} onSave={() => {}} id={id} isPdf />
                {hasDocuments && (
                    <Box sx={styles.container}>
                        <DotLegalHeader marginBottom={1} headerStyle={"small"}>
                            {translateString("documents")}
                        </DotLegalHeader>
                        <IncidentDocumentTable incidentId={id!} isLoading={documentsIsLoading} documents={documents} isPdf />
                    </Box>
                )}
            </Box>
            <Box sx={{ backgroundColor: "white" }} className={"page-break-before"}>
                <DotLegalPdfBackPage />
            </Box>
        </Box>
    );
}

export default IncidentLogPdf;
